define('core/modules/carousel',["jquery", "core/global/state", "libs/enquire", "core/modules/contentList", "core/ef_plugins/swipe"], function ($, state, enquire, contentlist) {
    return {
        init: function () {
            console.log('carousel');
            //modern browsers set up enquire breakpoint then set up equal height
            if (!state.oldIe()) {
                var $fromCarouselTarget = $('#from-carousel.carousel');

                enquire.register("screen and (max-width : 640px)", {
                    match: function () {
                        plugin = $fromCarouselTarget.data('Swipe');
                        if (!plugin) { // If null or undefined
                            // Set up carousel
                            $fromCarouselTarget.Swipe({
                                callback: function (event, index, slide) {
                                    dataLayer.push({ 'event': 'swipe', 'context': 'Carousel', 'position': index + 1 });
                                }
                            });
                        }
                    },
                    unmatch: function () {
                        plugin = $fromCarouselTarget.data('Swipe');
                        if (plugin) { // If not null or undefined
                            // Destroy carousel
                            plugin.kill();
                        }
                    }
                });
                //equal height set up
                contentlist.init();
            }
            //old IE just set up equal height
            else {
                contentlist.init();
            } 
        }
    }
});
